module.exports = __webpack_public_path__ + "static/media/ipe-amarelo_thumb.750d9c97.jpg";